export default "/unterm2/js/webpack/webfonts/chinese.msyh.ttf";